import { CSSObject } from '@emotion/css'

const disabledFeatures: string[] = []
export const disableCssSupportForTesting = (featureQuery: string) => {
    disabledFeatures.push(featureQuery)
}

export function supports(featureQuery: string, styleObject: CSSObject) {
    /**
     * Used to temporarily surpress jsdom output on @supports using the latest Jest, only returns void on NODE_ENV = test
     * otherwise goes ahead and returns the @supports object
     */
    if (process.env.NODE_ENV === 'test') {
        return {}
    }

    return () => {
        if (disabledFeatures.indexOf(featureQuery) !== -1) {
            return {}
        }

        return {
            [`@supports (${featureQuery})`]: styleObject,
        }
    }
}
